import React, { useRef } from "react";
import { useDispatch } from "react-redux";

import { Form } from "devextreme-react";
import { SimpleItem } from "devextreme-react/form";
import { Label } from "devextreme-react/chart";

import { horizontalAlignmentType, verticalAlignmentType } from "./data";
import ButtonOKCancel from "./ButtonOKCancel";
import { updateChartTitleAlignment } from "./Redux/chartTitleSlice";

export default function ChartTitleAlignmentContainer(props) {
  const { chartTitleAlignmentPopupRef } = props;

  const formRef = useRef(null);

  const dispatch = useDispatch();

  const horizontalAlignmentEditorOptions = {
    items: horizontalAlignmentType,
    showClearButton: true,
  };

  const verticalAlignmentEditorOptions = {
    items: verticalAlignmentType,
    showClearButton: true,
  };

  const onCancelClick = (e) => {
    chartTitleAlignmentPopupRef.current.instance.hide();
  };

  const onOkClick = (e) => {
    dispatch(
      updateChartTitleAlignment(formRef.current.instance.option("formData"))
    );

    chartTitleAlignmentPopupRef.current.instance.hide();
  };

  return (
    <React.Fragment>
      <Form ref={formRef}>
        <SimpleItem
          dataField="horizontalAlignment"
          editorType="dxSelectBox"
          editorOptions={horizontalAlignmentEditorOptions}
        >
          <Label text="가로 정렬" />
        </SimpleItem>
        <SimpleItem
          dataField="verticalAlignment"
          editorType="dxSelectBox"
          editorOptions={verticalAlignmentEditorOptions}
        >
          <Label text="세로 정렬" />
        </SimpleItem>
      </Form>
      <ButtonOKCancel onCancelClick={onCancelClick} onOkClick={onOkClick} />
    </React.Fragment>
  );
}
